import { useEffect, useState } from "react";
import { useDependency } from "../../../../contexts/DependencyProvider";
import { GetProjectRequest } from "../../../../services/soap/project/requests/GetProjectRequest";
import { ILayoutComponentProps, LayoutComponent } from "../LayoutComponent";
import styles from './TrackingLineComponent.module.css'
import { ComboBox, Content, Flex, Item, Link, ProgressCircle, ToastQueue, View } from "@adobe/react-spectrum";
import ReferenceMarketingChanelDropDown from "../../../../pages/protected/contacts/component/formComponents/ReferenceMarketingChanelDropDown";
import UserDropDown from "../../../../pages/protected/contacts/component/formComponents/UserDropDown";
import { useTranslation } from "react-i18next";
import { ListMessageActionRequest } from "../../../../services/soap/message/requests/ListMessageActionRequest";
import { CopyIcon, EditIcon } from "../../Icons/IconsLib";
import { UpdateProjectRequest } from "../../../../services/soap/project/requests/UpdateProjectRequest";


export interface ITrackingCodeLineProps extends ILayoutComponentProps {

}
function TrackingCodeLine({ selectedItem }: ITrackingCodeLineProps) {
    const { t } = useTranslation('contacts');
    const _t = (key: string) => t(`addNewCompany.${key}`, { ns: 'contacts' });
    const _tt = (key: string) => t(`contact_common.${key}`, { ns: 'contacts' });
    const _tm = (key: string) => t(key, { ns: 'contacts' });
    const [project, setProject] = useState<any>({})
    const { store, projectService, messageService } = useDependency();
    const [selectedChanel, setSelectedChannel] = useState<any>('');
    const [selectedUser, setSelectedUser] = useState<any>('');
    const [selectedReferenceCode, setSelectedReferenceCode] = useState<any>('');
    const [listMessageAction, setListMessageAction] = useState<any>([])
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [refStandardtype, setRefStandardType] = useState<any>('');
    const [showLoader, setShowLoader] = useState<boolean>(false)

    useEffect(() => {
        getListMessageAction();
    }, [])

    useEffect(() => {
        getProject(selectedItem?.id)
    }, [selectedItem])

    const getProject = async (id: any) => {
        const projectResult = await projectService.getProject(new GetProjectRequest(store.Server, store.SessionId, id))

        if (projectResult.result === 'OK') {
            setProject(projectResult.PROJECT)
        }
    }

    const getListMessageAction = async () => {
        const response = await messageService.listMessageAction(new ListMessageActionRequest(store.Server, store.SessionId, {
            limit: 100,
            offset: 0
        }));
        setListMessageAction(response?.ROW || [])
    }

    const onCopy = async () => {
        try {
            const code = project.trackingCode;
            await navigator.clipboard.writeText(code);
            ToastQueue.positive(_tm('tracking_code_copied'), { timeout: 100 });
        } catch (err) {
                  ToastQueue.negative(_tm('failed_to_copy_tracking_code'), { timeout: 100 });
        }
    };

    const onEdit = () => {
        setIsEdit(true);
    }

    const getTrackingcode = () => {
        let trackingCode = '';
        if (refStandardtype === '2') {
            trackingCode = selectedUser
        } else if (refStandardtype === '3') {
            trackingCode = selectedReferenceCode
        } else {
            trackingCode = selectedChanel
        }
        return trackingCode;
    }

    const updateProject = async () => {
        setShowLoader(true)
        const code = getTrackingcode();
        setProject((prov: any) => ({
            ...prov,
            trackingCode: code
        }));

        const updateResult = await projectService.updateProject(new UpdateProjectRequest(store.Server, store.SessionId, { ...project, trackingCode: code }))

        if (updateResult.result === 'OK') {
            setShowLoader(false);
            ToastQueue.positive(_tm('tracking_code_saved_successfully'), { timeout: 100 });
            onCancel();
        }
    }

    const onCancel = () => {
        setSelectedChannel('')
        setSelectedReferenceCode('')
        setSelectedUser('')
        setRefStandardType('')
        setIsEdit(false);
    }

    return (
        <Flex UNSAFE_className={styles.tracking_code_heading_parent} direction={'column'}>
            <View UNSAFE_className={styles.title}>{_t("marketing_channel")}</View>
            <View UNSAFE_className={styles.tracking_code_box_wrapper}>
                {!isEdit ? (
                    <Flex direction={'row'} justifyContent={'space-between'}>
                        <Flex direction={'column'} gap={'size-100'}>
                            {/* <Content>
                                <b>Tracking code</b>
                            </Content> */}
                            <Content>
                                {project?.trackingCode}
                            </Content>
                        </Flex>
                        {/* <Flex direction={'column'} gap={'size-100'}>
                            <Content>
                                <b>User</b>
                            </Content>
                            <Content>
                                {project?.trackingCode}
                            </Content>
                        </Flex> */}


                        <Flex direction={'row'} UNSAFE_className={styles.action_btn_container}>
                            <div className={styles.action_btn} onClick={onEdit}>
                                <EditIcon size={32} />
                            </div>
                            <div className={styles.action_btn} onClick={onCopy}>
                                <CopyIcon size={32} />
                            </div>
                        </Flex>
                    </Flex>
                ) : (
                    <>
                        <Flex direction={{ base: 'column', L: 'row' }} gap={'size-100'}>
                            <ReferenceMarketingChanelDropDown
                                selectedChanel={selectedChanel}
                                onChange={(channel) => {
                                    const { refId, refName, refStandardtype } = channel;
                                    setSelectedChannel(refName)
                                    setRefStandardType(refStandardtype);
                                }}
                            />
                            <UserDropDown
                                selectedUser={selectedUser}
                                onChange={(user) => {
                                    const { id, userName } = user;
                                    setSelectedUser(userName);
                                }}
                                isRequired={refStandardtype === '2'}
                                isHidden={refStandardtype !== '2'}
                            />
                            <ComboBox
                                label={_t("reference_code")}
                                aria-label={_t("reference_code")}
                                items={listMessageAction}
                                selectedKey={selectedReferenceCode}
                                onSelectionChange={(value) => {
                                    setSelectedReferenceCode(value);
                                }}
                                width={{ base: "100%", L: "50%" }}
                                isRequired={refStandardtype === '3'}
                                isHidden={refStandardtype !== "3"}
                            >
                                {(item: any) => (
                                    <Item key={item.code} textValue={item.code}>
                                        {item.code}
                                    </Item>
                                )}
                            </ComboBox>
                        </Flex>
                        <Flex direction={{ base: 'row', L: 'row' }} justifyContent={'end'} gap={'size-200'} marginTop={'size-200'} width={'100%'}>
                            <Flex>
                                <Link UNSAFE_className={styles.btn_cancel} isQuiet onPress={onCancel}>
                                    {t('cancel', { ns: 'layout_components' })}
                                </Link>
                            </Flex>
                            <Flex>
                                <Link width={'100px'} UNSAFE_className={styles.btn_confirm} isQuiet onPress={updateProject}>
                                    {_tt('button_save')}
                                </Link>
                            </Flex>
                            <ProgressCircle aria-label={t('loading', { ns: 'layout_components' })} isIndeterminate isHidden={!showLoader} />
                        </Flex>
                    </>
                )}
            </View>
        </Flex>

    )
}

export const TrackingCodeLineComponent = LayoutComponent(TrackingCodeLine)
